import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import AuthManager from '../../../store/auth-manager';
import { FeatureConfigRules } from '../../../constants/feature-config-rules';

function useAuthorisedList(originalList) {
  const userInfo = useSelector(({ user }) => user);
  const { config } = useSelector(({ featureConfig }) => featureConfig);
  const workflowBuilderConfig = useSelector(({ workflowBuilderConfig: wbc }) => wbc) || {};
  const impersonateUserInfo = useSelector(({ impersonateUser }) => impersonateUser) || {};

  // Feature config rules evaluate over the org feature config plus the live workflow
  // builder config; merge a new slice here to gate items on another config source.
  const featureConfigState = { ...config, ...workflowBuilderConfig };

  const filterListByAuthorisation = (list) => {
    let filteredList = [];
    for (let i = 0; i < list.length; i += 1) {
      const {
        featureId, featureConfigId, restrictImpersonators,
      } = list[i];
      if ((!featureId || AuthManager.isAuthorised(featureId))
        && (!featureConfigId || FeatureConfigRules[featureConfigId](featureConfigState))
        && (!impersonateUserInfo.active || !restrictImpersonators)) {
        const listItemClone = { ...list[i] };
        if (listItemClone.children) {
          listItemClone.children = filterListByAuthorisation(listItemClone.children);
        }

        filteredList = [...filteredList, listItemClone];
      }
    }

    return filteredList;
  };

  const filteredList = useMemo(() => (
    filterListByAuthorisation(originalList)
  ), [userInfo, originalList, impersonateUserInfo.active, config, workflowBuilderConfig]);

  return [filteredList];
}

export default useAuthorisedList;
